<template>
  <div>
    <accurate-filter @change="onChange" />
    <br />
    <workflow-use-rate :filter-form="filterForm" />
    <br />
    <workflow-use-count :filter-form="filterForm" />
  </div>
</template>
<script>
import AccurateFilter from '@/pages/data/accurate/components/AccurateFilter.vue';
import WorkflowUseRate from '@/pages/data/accurate/components/WorkflowUseRate.vue';
import WorkflowUseCount from '@/pages/data/accurate/components/AccurateUseCount.vue';
import moment from 'moment/moment';

export default {
  components: {
    WorkflowUseCount,
    WorkflowUseRate,
    AccurateFilter
  },
  data() {
    return {
      filterForm: {
        begin_date: moment().subtract(1, 'month').add(1, 'day').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD')
      }
    };
  },
  mounted() {
  },
  methods: {
    onChange(checkedDate) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD')
      };
    }
  }
};
</script>
<style lang="less" scoped>
.customer-col {
  margin-top: 16px;
}

/deep/ .ant-col-8 {
  padding-left: 3px !important;
  padding-right: 3px !important;
}
</style>
